module.exports = __webpack_public_path__ + "static/media/analysis.3ca5e9b0.svg";